module.exports = __webpack_public_path__ + "img/ad-support-xs.e4433d5e.jpg";